/*****************优惠券发行管理*****************/
const couponCreatecomplete = resolve => require(['@/pages/couponactivities/couponmanagement/children/createcomplete.vue'], resolve);
const createcomplete = resolve => require(['@/pages/couponactivities/couponmanagement/createcomplete/index.vue'], resolve);

const coupon = resolve => require(['@/pages/marketing/coupon/index.vue'], resolve);
const createcondition = resolve => require(['@/pages/couponactivities/couponmanagement/children/createcondition.vue'], resolve);
const createcoupon = resolve => require(['@/pages/couponactivities/couponmanagement/children/createbasic.vue'], resolve);
const couponinfo = resolve => require(['@/pages/couponactivities/couponmanagement/children/couponinfo.vue'], resolve);
const couponmanagement = resolve => require(['@/pages/couponactivities/couponmanagement/ECoupon.vue'], resolve);
/*****************优惠券信息管理*****************/
const informationManage = resolve => require(['@/pages/couponactivities/informationManage/index.vue'], resolve);
const info = resolve => require(['@/pages/couponactivities/informationManage/children/info.vue'], resolve);
/*****************优惠券发行审核*****************/
const issuanceAudit = resolve => require(['@/pages/couponactivities/issuanceAudit/index.vue'], resolve);
const audit = resolve => require(['@/pages/couponactivities/issuanceAudit/children/audit.vue'], resolve);
/* ******************优惠券营销工具管理********************* */
const couponTool= resolve => require(['@/pages/couponactivities/couponTool/index.vue'],resolve)
const couponToolCreate =resolve => require(['@/pages/couponactivities/couponTool/create.vue'],resolve)
const couponToolDetail = resolve =>require(['@/pages/couponactivities/couponTool/detail.vue'],resolve)

export default [
    //优惠券发行管理
    {
        path: "/couponmanagement",
        name: "优惠券管理",
        component: couponmanagement,
        meta: {
            keepAlive: true
        }
    },
    /*优惠券管理下路由开始*/
    {
        path: "/couponmanagement/couponinfo",
        name: "查看优惠券",
        component: couponinfo
    },
    {
        path: "/couponmanagement/createcoupon",
        name: "创建优惠券活动",
        component: createcoupon
    },
    {
        path: "/couponmanagement/createcondition",
        name: "优惠券管理选择店铺或优惠券",
        component: createcondition
    },
    {
        path: "/couponmanagement/coupon",
        name: "优惠券管理创建优惠券",
        component: coupon
    },
    /*被引用较多，暂没处理*/
    {
        path: "/createcomplete",
        name: "创建优惠券完成",
        component: createcomplete
    },
    {
        path: "/couponmanagement/createcomplete",
        name: "创建完成",
        component: couponCreatecomplete
    },
    /*被引用较多，暂没处理*/
    /*优惠券管理下路由结束*/

    //优惠券信息管理
    {
        path: "/informationManage",
        name: "优惠券信息管理",
        component: informationManage,
        meta: {
            keepAlive: true
        }
    },
    /*优惠券信息管理下路由开始*/
    {
        path: "/informationManage/info",
        name: "查看优惠券信息",
        component: info,
    },
    /*优惠券信息管理下路由结束*/

    //优惠券发行审核
    {
        path: "/issuanceAudit",
        name: "优惠券发行审核",
        component: issuanceAudit,
        meta: {
            keepAlive: true
        }
    },
    /*优惠券发行审核下路由开始*/
    {
        path: "/issuanceAudit/audit",
        name: "优惠券审核",
        component: audit,
    },
    /*优惠券发行审核下路由结束*/

    /* 优惠券信息管理开始 */
    {
        path:'/couponTool',
        component:couponTool,
        meta: {
            keepAlive: true
        }
    },
    {
        path:'/couponTool/create',
        component:couponToolCreate,
    },
    {
        path:'/couponTool/detail',
        component:couponToolDetail,
    },
]
